import { Checkbox as AntdCheckbox } from "antd";
import type { CheckboxProps } from "antd";
import type { CheckboxGroupProps } from "antd/es/checkbox";

const Checkbox = (props: CheckboxProps) => {
  return <AntdCheckbox {...props} />;
};

const Group = (props: CheckboxGroupProps) => {
  return <AntdCheckbox.Group {...props} />;
};

Checkbox.Group = Group;

export { Checkbox };
